import { createFileRoute } from "@tanstack/react-router";

// `id` = mã phiếu cần mở ngay — chuông báo của khiếu nại dẫn tới
// `/complaints?id=<mã phiếu>` (QĐ 0326).
type ComplaintsSearch = { id?: string | undefined };

export const Route = createFileRoute("/_app/complaints/")({
  validateSearch: (search: Record<string, unknown>): ComplaintsSearch => ({
    id: typeof search.id === "string" && search.id ? search.id : undefined,
  }),
});
